import { action, observable } from 'mobx';

export class LayoutStore {
    @observable
    public sidebarCollapsed: boolean = false;

    @action
    public readonly toggleSidebar = (status = !this.sidebarCollapsed) => {
        this.sidebarCollapsed = status;
    };
}

export default new LayoutStore();
